import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SessionExpiredScreen } from '@/screens/accounts/SCR-111-114-info'

// SCR-111 Signed out / session expired (accounts area).
export const Route = createFileRoute('/_public/session-expired')({
  validateSearch: z.object({ next: z.string().max(2000).optional().catch(undefined) }),
  component: function SessionExpired() {
    return <SessionExpiredScreen search={Route.useSearch()} />
  },
})
